export default {"src":"/inst/_next/static/media/logo-s-pet.41571f21.svg","height":40,"width":96,"blurWidth":0,"blurHeight":0};